import { motion } from "framer-motion"

const variants = {
    open: {
        y: 0,
        opacity: 1,

        transition: {
            y: { stiffness: 100, velocity: 100 },
            opacity: { stiffness: 100, velocity: 100 },
        },
    },
    closed: {
        y: 20,
        opacity: 0,

        transition: {
            y: { stiffness: 1000 },
        },
    },
}
const MonterItem = ({ children, className }) => {
    return (
        <motion.div className={className} variants={variants}>
            {children}
        </motion.div>
    )
}

export default MonterItem
